import React from 'react';

interface TimerProps {
  seconds: number;
  onTimeout: () => void;
  timeRemaining: number;
}

export const Timer: React.FC<TimerProps> = ({ timeRemaining }) => {
  const minutes = Math.floor(timeRemaining / 60);
  const secs = timeRemaining % 60;

  const isLow = timeRemaining <= 10;

  return (
    <div className={`timer ${isLow ? 'timer-low' : ''}`}>
      <span className="timer-icon">&#9201;</span>
      <span className="timer-value">
        {minutes}:{secs.toString().padStart(2, '0')}
      </span>
    </div>
  );
};
